var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _line, _line2, _line3, _line4, _circle, _path12, _path13, _path14, _path15, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _rect, _path16, _path17, _rect2, _path18, _path19, _path20, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 310,
    viewBox: "0 0 462 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 171.485C-6.1751e-05 199.371 23.2997 265.967 73.7001 295.259C125.162 325.168 168.309 300.143 228.997 301.129C274.835 301.875 303.081 315.104 346.39 301.129C407.669 281.357 474.154 247.458 460.099 188.608C450.325 147.682 403.777 148.346 374.818 116.203C345.928 84.1383 349.027 51.0342 313.225 25.6969C235.728 -29.1496 141.214 11.9455 68.9622 72.6623C32.2499 103.513 6.17513e-05 143.599 0 171.485Z",
    fill: "#031A6B",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.22 117.5C99.2197 167.1 138.553 205.833 163.22 219V222.5C96.0197 182.5 119.22 135.833 139.22 117.5Z",
    fill: "#CAD0E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.72 114.5C150.72 109.833 170.32 98.8 176.72 92C166.886 92.3333 146.12 97.3 141.72 114.5Z",
    fill: "#CAD0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.22 132.5C138.553 133.5 152.02 132.6 163.22 121C156.646 118.833 141.444 118.1 133.22 132.5Z",
    fill: "#CAD0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.22 161.5C131.553 159.667 142.72 152.7 144.72 139.5C137.22 139.667 123.02 144.3 126.22 161.5Z",
    fill: "#CAD0E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.22 187.5C137.386 185.333 145.22 177.1 143.22 161.5C136.053 163.333 124.02 171.1 133.22 187.5Z",
    fill: "#CAD0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.22 211C157.053 205.833 159.12 193.3 152.72 184.5C146.553 187.667 138.42 197.4 155.22 211Z",
    fill: "#CAD0E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.72 214C140.886 209 128.82 198.2 111.22 195C115.053 203.5 127.12 219.2 144.72 214Z",
    fill: "#CAD0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.22 187.5C120.386 180.5 112.02 165.8 101.22 163C100.071 171.167 102.864 187.5 123.22 187.5Z",
    fill: "#CAD0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.22 160C116.72 151.333 115.62 133.2 107.22 130C102.553 137.333 97.8198 153.6 116.22 160Z",
    fill: "#CAD0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.22 130C123.22 130 134.72 118.5 128.22 100C121.22 106.567 110.42 121.76 123.22 130Z",
    fill: "#CAD0E1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 401.431,
    y1: 247.229,
    x2: 401.431,
    y2: 249.64,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 401.431,
    y1: 251.944,
    x2: 401.431,
    y2: 254.354,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 397.896,
    y1: 250.819,
    x2: 400.306,
    y2: 250.819,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 402.61,
    y1: 250.819,
    x2: 405.021,
    y2: 250.819,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 147,
    r: 24,
    stroke: "#CAD0E1",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeDasharray: "4.5 6.75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.937 93.2392C121.937 94.8813 120.606 96.2124 118.964 96.2124C117.322 96.2124 115.991 94.8813 115.991 93.2392C115.991 91.5971 117.322 90.266 118.964 90.266C120.606 90.266 121.937 91.5971 121.937 93.2392Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.125
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.509 29.5357C286.509 31.1778 285.178 32.5089 283.536 32.5089C281.894 32.5089 280.562 31.1778 280.562 29.5357C280.562 27.8937 281.894 26.5625 283.536 26.5625C285.178 26.5625 286.509 27.8937 286.509 29.5357Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.125
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M319.937 169.846C319.937 171.488 318.606 172.82 316.964 172.82C315.322 172.82 313.991 171.488 313.991 169.846C313.991 168.204 315.322 166.873 316.964 166.873C318.606 166.873 319.937 168.204 319.937 169.846Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.125
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5089 208.536C97.5089 210.178 96.1778 211.509 94.5357 211.509C92.8937 211.509 91.5625 210.178 91.5625 208.536C91.5625 206.894 92.8937 205.562 94.5357 205.562C96.1778 205.562 97.5089 206.894 97.5089 208.536Z",
    stroke: "#CAD0E1",
    strokeWidth: 1.125
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 325.098,
    y1: 101.563,
    x2: 325.098,
    y2: 103.973,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 325.098,
    y1: 106.277,
    x2: 325.098,
    y2: 108.688,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 321.562,
    y1: 105.152,
    x2: 323.973,
    y2: 105.152,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 326.277,
    y1: 105.152,
    x2: 328.687,
    y2: 105.152,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 332.848,
    y1: 186.909,
    x2: 332.848,
    y2: 189.32,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 332.848,
    y1: 191.624,
    x2: 332.848,
    y2: 194.034,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 329.312,
    y1: 190.499,
    x2: 331.723,
    y2: 190.499,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 334.027,
    y1: 190.499,
    x2: 336.438,
    y2: 190.499,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.507,
    y: 54.1086,
    width: 50.9153,
    height: 27.9575,
    rx: 1.125,
    transform: "rotate(-26.3526 192.507 54.1086)",
    stroke: "#CAD0E1",
    strokeWidth: 2.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.062 54.1244L249.788 56.5594C250.406 56.6179 250.955 56.1639 251.014 55.5454C251.072 54.9268 250.618 54.3779 250 54.3194L225.368 51.988L224.062 54.1244ZM219.025 56.6194L216.534 56.3641L203.464 77.3721C203.135 77.8996 203.297 78.5934 203.824 78.9216C204.352 79.2498 205.046 79.0882 205.374 78.5607L219.025 56.6194Z",
    fill: "#CAD0E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.156 55.0042L222.329 56.7335L238.63 32.4772",
    stroke: "#CAD0E1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 291.484,
    y: 197.209,
    width: 53.2862,
    height: 29.3046,
    rx: 1.125,
    transform: "rotate(24.0179 291.484 197.209)",
    stroke: "#CAD0E1",
    strokeWidth: 2.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.575 222.664L327.743 244.964C328.093 245.478 328.793 245.611 329.306 245.262C329.82 244.912 329.953 244.213 329.604 243.699L315.054 222.308L312.575 222.664ZM307.127 220.236L305.734 218.155L280.1 221.64C279.485 221.724 279.053 222.29 279.137 222.906C279.221 223.522 279.788 223.953 280.403 223.869L307.127 220.236Z",
    fill: "#CAD0E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M291.04 198.543L309.086 223.167L339.462 220.12",
    stroke: "#CAD0E1",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.434 217.208C266.815 216.853 267.733 215.959 268.913 215.767L271.088 215.414C272.058 215.257 272.494 215.712 271.914 216.277L270.881 217.284C270.301 217.849 269.085 218.154 268.575 217.862L267.434 217.208Z",
    fill: "black",
    fillOpacity: 0.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 320.904,
    y1: 109.795,
    x2: 312.795,
    y2: 117.996,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 328.904,
    y1: 194.795,
    x2: 320.796,
    y2: 202.996,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 122.386,
    y1: 272,
    x2: 127.778,
    y2: 277.392,
    stroke: "#CAD0E1",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 132.993,
    y1: 282.606,
    x2: 138.385,
    y2: 287.998,
    stroke: "#CAD0E1",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 122.828,
    y1: 287.998,
    x2: 128.22,
    y2: 282.607,
    stroke: "#CAD0E1",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 133.435,
    y1: 277.392,
    x2: 138.827,
    y2: 272,
    stroke: "#CAD0E1",
    strokeWidth: 3.375,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 319.902,
    y1: 113.795,
    x2: 305.795,
    y2: 127.997,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 327.903,
    y1: 198.795,
    x2: 313.796,
    y2: 212.997,
    stroke: "#CAD0E1",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 60.9707C134.97 60.9707 138.945 60.3296 140.637 58.6373C142.33 56.945 142.971 52.9706 142.971 52.9706C142.971 52.9706 143.612 56.945 145.304 58.6373C146.996 60.3296 150.971 60.9707 150.971 60.9707C150.971 60.9707 146.996 61.6118 145.304 63.3041C143.612 64.9964 142.971 68.9708 142.971 68.9708C142.971 68.9708 142.33 64.9964 140.637 63.3041C138.945 61.6118 134.97 60.9707 134.97 60.9707Z",
    fill: "#CAD0E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M307 68C307 68 310.974 67.3589 312.667 65.6666C314.359 63.9743 315 59.9999 315 59.9999C315 59.9999 315.641 63.9743 317.334 65.6666C319.026 67.3589 323 68 323 68C323 68 319.026 68.6411 317.334 70.3334C315.641 72.0257 315 76.0001 315 76.0001C315 76.0001 314.359 72.0257 312.667 70.3334C310.974 68.6411 307 68 307 68Z",
    fill: "#CAD0E1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180 278C180 278 183.974 277.359 185.667 275.667C187.359 273.974 188 270 188 270C188 270 188.641 273.974 190.334 275.667C192.026 277.359 196 278 196 278C196 278 192.026 278.641 190.334 280.333C188.641 282.026 188 286 188 286C188 286 187.359 282.026 185.667 280.333C183.974 278.641 180 278 180 278Z",
    fill: "#CAD0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer4);
export default __webpack_public_path__ + "static/media/Layer_4.27a83dd3d0fa1515927d3d968ea52460.svg";
export { ForwardRef as ReactComponent };